import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableConsumerSearchHome = loadable(
  () => import('./ConsumerSearchHome'),
  {
    fallback: <LoadingScreen />,
  },
);

export default LoadableConsumerSearchHome;
